import useScroll from '../../../hook/useScroll';
import { HeaderSlot } from '../../../utils/constants';
import Back from './Back';
import Name from './Name';
import Type from './Type';
import Search from './Search';
import Transaction from './Transaction';
import CustomerCare from './CustomerCare';

const renderSlot = (slot = null) => {
  if (!slot) return null;

	if (Array.isArray(slot?.content)) {
		return slot.content.map((item, index) => {
			const normalizedItem = typeof item === 'string' ? { content: item } : item;
			return (
				<div key={index} className={normalizedItem?.className || ''}>
					{renderSlot(normalizedItem)}
				</div>
			);
		});
	}

	const ComponentMap = {
		[HeaderSlot.BACK]: Back,
		[HeaderSlot.NAME]: Name,
		[HeaderSlot.TYPE]: Type,
		[HeaderSlot.SEARCH]: Search,
		[HeaderSlot.TRANSACTION]: Transaction,
		[HeaderSlot.CUSTOMERCARE]: CustomerCare,
	};

	const Component = ComponentMap[slot?.content];

  return <Component {...slot} />;
};

export const RelativeHeader = (props) => {
	const { slots, parent } = props;

	return (
		<div className={`relative transition-all duration-300 ease-in-outz-[3] ${parent?.className?.first}`}>
			<div className='w-full mx-auto mb-4'>
				<div className='flex flex-row justify-between items-center'>
					{renderSlot(slots?.left)}
					{renderSlot(slots?.center)}
					{renderSlot(slots?.right)}
				</div>
			</div>
			{parent?.border?.bottom && <div className='border-t-1 border-solid border-gray-200 -mx-4' />}
		</div>
	);
};

const Header = (props) => {
	const { isScrolled } = useScroll();
	const { slots } = props;

	return (
		<div
			className={`fixed max-w-3xl mx-auto top-0 left-0 right-0 transition-all duration-300 ease-in-out
				${isScrolled ? 'bg-white shadow-md !z-[5]' : 'z-[3]'}
			`}
		>
			<div className='w-full max-w-3xl mx-auto px-4 py-4'>
				<div className='flex flex-row justify-between items-center'>
					{renderSlot(slots?.left)}
					{renderSlot(slots?.center)}
					{renderSlot(slots?.right)}
				</div>
			</div>
		</div>
	);
};

export default Header;
